
/**
 * Return an array of IProgram based on the programs section of the store
 * @param {object} progStore The store object
 * @returns {array} IProgram {id: string, name: string, siteId: string, disabled: bool}
 */
export function getAllPrograms(progStore) {
  const { allPrograms } = progStore || {};
  const iPrograms = [];

  if (!!allPrograms && !allPrograms.err && allPrograms.isValid && !allPrograms.isFetching &&
        !!allPrograms.data && !!allPrograms.data.results && allPrograms.data.results.length > 0) {
    for (var progIdx = 0; progIdx < allPrograms.data.results.length; progIdx++) {
      const curResult = allPrograms.data.results[progIdx];
      const iProg = { id: curResult.id, name: curResult.name, siteId: curResult.siteId, disabled: curResult.disabled};
      iPrograms.push(iProg);
    }
  }

  return iPrograms;
}

/**
 * Get the set of program ids for the supplied response id, from the touchpoints section
 * of the store.
 * @param {string} responseId Touchpoint response id (guid format)
 * @returns {array} Array of program id guids; will be empty if none are found
 */
export function getProgramsFromTouchpointResponse(touchpointStore, responseId) {
  const { touchpointResponses } = touchpointStore;
  var progIds = [];
  const response = !!touchpointResponses && touchpointResponses.get(responseId);
  if (!!response) {
    const data = response.data;
    if (!!data) {
      const programs = data.programs;
      if (!!programs && programs.length > 0) {
        progIds = programs.map(prog => prog.programId);
      }
    }
  }

  return progIds;
}



// WEBPACK FOOTER //
// src/common/program-utilities.js